var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpdates = function SvgUpdates(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3367 3.08337C11.9264 3.08345 11.533 3.24711 11.2437 3.5381L3.6016 11.1809C3.27128 11.4744 3.08267 11.8954 3.08371 12.3373V32.3809C3.08711 33.2277 3.77265 33.9133 4.61936 33.9167C11.2999 33.9167 17.9805 33.9167 24.661 33.9167C25.069 33.9182 25.461 33.758 25.751 33.471L25.7541 33.4741L33.4715 25.756C33.758 25.4646 33.9172 25.0715 33.9141 24.6629V4.70651C33.9607 3.82583 33.2602 3.0857 32.3784 3.08339L12.3367 3.08337ZM12.975 6.17002H28.6567L24.0347 10.7894C18.8075 10.7894 13.5803 10.7894 8.35306 10.7894L12.975 6.17002ZM30.8307 8.35325V24.0274L26.2087 28.6558V12.9757L30.8307 8.35325ZM6.17004 13.8731H23.1254V30.8331H6.17004V13.8731Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpdates, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/updates.62f88a1e.svg";
export { ForwardRef as ReactComponent };